// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__10Dkm","rootCenter":"LoadMoreObserver_rootCenter__1c4lv","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__151e6"};